// Static fixtures used only by the critical-CSS extraction pass so it can paint a
// populated grid. The data never reaches users - extraction keeps the captured
// CSS selectors and discards the rendered HTML.
const MOCK_EXTRACTION_MODELS = Array.from({ length: 4 }, (_, index) => ({
  id: `mock-${index}`,
  title: 'Model title',
  prompt: 'Prompt text',
  createdAt: '2026-01-01T00:00:00Z',
  image: '',
  authorAvatar: '',
}))

export default MOCK_EXTRACTION_MODELS
